import { render, staticRenderFns } from "./VehicleRegistDialog.vue?vue&type=template&id=715da7da&scoped=true&"
import script from "./VehicleRegistDialog.vue?vue&type=script&lang=js&"
export * from "./VehicleRegistDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715da7da",
  null
  
)

export default component.exports